


















































































import Vue from 'vue';
import { mapState } from 'vuex';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
  },
  data() {
    return {
      creating: false,
      pushing: false,
      importedTopic: null,
    };
  },
  computed: {
    ...mapState({
      boardSubsection: (state: any) => state.boardSubsections.board_subsection,
      boardSections: (state: any) => state.boardSections.board_sections,
      boardSection: (state: any) => state.boardSections.board_section,
      topics: (state: any) => state.descomplica.topics,
    }),
  },
  watch: {
    importedTopic: function(newTopic, oldTopic) {
      if (newTopic) {
        this.boardSubsection.title = newTopic.name;
        this.boardSubsection.descomplicaTopicSlug = newTopic.slug;
        this.boardSubsection.boardSectionByBoardSectionId = this.boardSection;
      } else {
        this.boardSubsection.title = null;
        this.boardSubsection.descomplicaTopicSlug = null;
        this.boardSubsection.boardSectionByBoardSectionId = { id: null };
      }
    },
  },
  async created() {
    this.creating = this.$route.name === 'board_subsection_create';
    if (this.creating) {
      this.$store.commit('SET_EMPTY_BOARD_SUBSECTION');
      await this.$store.dispatch('PULL_DESCOMPLICA_TOPICS', {
        subjectSlug: this.boardSection.descomplicaSubjectSlug,
        disciplineSlug: this.boardSection.boardByBoardId
          .descomplicaDisciplineSlug,
      });
    } else {
      let boardSubsectionId = parseInt(this.$route.params.boardSubsectionId);
      await this.$store.dispatch('PULL_BOARD_SUBSECTION', boardSubsectionId);
      await this.$store.dispatch('PULL_DESCOMPLICA_TOPICS', {
        subjectSlug: this.boardSubsection.boardSectionByBoardSectionId
          .descomplicaSubjectSlug,
        disciplineSlug: this.boardSubsection.boardSectionByBoardSectionId
          .boardByBoardId.descomplicaDisciplineSlug,
      });
    }
  },
  methods: {
    push: async function() {
      if (this.pushing === false) {
        this.pushing = true;
        await this.$store.dispatch(
          'PUSH_BOARD_SUBSECTION',
          this.boardSubsection,
        );
        this.pushing = false;
        this.$router.go(-1);
      }
    },
    updateSection: async function(boardSectionId: number) {
      await this.$store.dispatch('PULL_BOARD_SECTION', boardSectionId);
      await this.$store.dispatch('PULL_DESCOMPLICA_TOPICS', {
        subjectSlug: this.boardSection.descomplicaSubjectSlug,
        disciplineSlug: this.boardSection.boardByBoardId
          .descomplicaDisciplineSlug,
      });
      this.boardSubsection.boardSectionByBoardSectionId = this.boardSection;
      this.boardSubsection.descomplicaTopicSlug = null;
    },
  },
});
